import { type WrappedInsight } from "@clipboard-health/contract-worker-app-bff";

import {
  AnimatedInsightWrapper,
  type AnimatedInsightWrapperProps,
} from "../AnimatedInsightWrapper";
import { ShareHeader } from "../ShareHeader";
import { EarningsContent } from "./Earnings/Content";
import { PatientsHelpedContent } from "./PatientsHelped/Content";
import { ShiftsWorkedContent } from "./ShiftsWorked/Content";
import { TopWorkplacesContent } from "./TopWorkplaces/Content";

interface KnownInsightContentContainerProps
  extends Pick<AnimatedInsightWrapperProps, "onClick" | "visible"> {
  insight: WrappedInsight;
}

export function KnownInsightContentContainer(props: KnownInsightContentContainerProps) {
  const { insight, visible, onClick } = props;

  const getContent = () => {
    switch (insight.attributes.insightType) {
      case "shifts-worked": {
        return (
          <>
            <ShareHeader invert />
            <ShiftsWorkedContent attributes={insight.attributes} />
          </>
        );
      }

      case "earnings": {
        return (
          <>
            <ShareHeader invert />
            <EarningsContent attributes={insight.attributes} />
          </>
        );
      }

      case "top-workplaces": {
        return (
          <>
            <ShareHeader />
            <TopWorkplacesContent attributes={insight.attributes} />
          </>
        );
      }

      case "patients-helped": {
        return (
          <>
            <ShareHeader invert />
            <PatientsHelpedContent attributes={insight.attributes} />
          </>
        );
      }

      default: {
        return null;
      }
    }
  };

  return (
    <AnimatedInsightWrapper
      insightType={insight.attributes.insightType}
      visible={visible}
      onClick={onClick}
    >
      {getContent()}
    </AnimatedInsightWrapper>
  );
}
